export enum CostCenterType {
  PROJECT,
  CO
}
